import type { NavItem } from './navigation';

const normalize = (s: string) =>
  s
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();

export function filterCommands(items: NavItem[], query: string): NavItem[] {
  const q = normalize(query.trim());
  if (!q) return items;
  return items.filter((it) =>
    [it.label, it.summary, ...it.keywords].some((field) => normalize(field).includes(q)),
  );
}
